// Vendor Imports
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { I18n } from 'common/i18n';

const scope = 'shared.visualizations.panes.presentation';

export class SwapControls extends Component {
  renderIcon = ({ name, iconClassName, label, onClick }) => {
    const { className } = this.props;
    const swapButtonClasses = classNames(className, `${iconClassName}-button`);

    return (
      <button type="button" className={swapButtonClasses} onClick={onClick} aria-label={label}>
        <span className={name}></span>
      </button>
    );
  };

  render() {
    const { index, onClick, showUpIcon, showDownIcon } = this.props;
    const arrowUpIconAttributes = {
      name: 'icon-arrow-up2',
      iconClassName: 'up-icon',
      label: I18n.t('fields.move_up', { scope }),
      onClick: () => onClick(index, index - 1),
    };
    const arrowDownIconAttributes = {
      name: 'icon-arrow-down2',
      iconClassName: 'down-icon',
      label: I18n.t('fields.move_down', { scope }),
      onClick: () => onClick(index, index + 1),
    };

    return (
      <div className="swap-controls">
        {showUpIcon && this.renderIcon(arrowUpIconAttributes)}
        {showDownIcon && this.renderIcon(arrowDownIconAttributes)}
      </div>
    );
  }
}

SwapControls.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  showUpIcon: PropTypes.bool,
  showDownIcon: PropTypes.bool,
};

export default SwapControls;
